import { createContext } from 'react';

const recordContext = createContext();

export default recordContext;
